// extracted by mini-css-extract-plugin
export default {"WrapperCollapse":"CollapseHeaderButton_WrapperCollapse__xCr-f"};